import './bootstrap';

import './utils';
// jQuery
import $ from 'jquery';
window.jQuery = window.$ = $

// Datatable
import DataTable from 'datatables.net-bs5';
window.DataTable = DataTable;

// moment //TODO, Add timezone moment
import moment from 'moment';
window.moment = moment;


// chart.js
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';

window.Chart = Chart;

// Chart js datalabels plugin
import ChartDataLabels from 'chartjs-plugin-datalabels';
window.ChartDataLabels = ChartDataLabels;

// Chart js annotations plugin
import annotationPlugin from 'chartjs-plugin-annotation';
window.annotationPlugin = annotationPlugin;
Chart.register(annotationPlugin);

// Chart js chartjs-plugin-zoom plugin
import zoomPlugin from 'chartjs-plugin-zoom';
Chart.register(zoomPlugin);

// Datatables

// import DataTable from "datatables.net";
// DataTable(window, window.$);

// Daterange picker
// import "daterangepicker/daterangepicker";

//helper
// import { Auth } from "./auth";
// window.Auth = Auth;
// Custom Components
import { PageDatatableList } from "./components/PageDatatableList";
window.PageDatatableList = PageDatatableList;

//TabControl
import { TabControl } from "./components/TabControl";
window.TabControl = TabControl;

//PageForm
import { PageForm } from "./components/PageForm";
window.PageForm = PageForm;

//TableForm
import { TableForm } from "./components/TableForm";
window.TableForm = TableForm;

//FormErrorMessage
import { FormErrorMessage } from "./components/FormErrorMessage";
window.FormErrorMessage = FormErrorMessage;

//Spinloader
import { SpinLoader } from "./components/SpinLoader";
window.SpinLoader = SpinLoader

// import { DashboardRenderer } from './components/DashboardRenderer';
// window.DashboardRenderer = DashboardRenderer;

// import { DataTableLoader } from "./components/DataTableLoader";
// window.DataTableLoader = DataTableLoader;

// import { CsrfKeepAlive } from "./components/CsrfKeepAlive";
// window.csrf = new CsrfKeepAlive();

// import { BootstrapModalDialog } from './components/BootstrapModalDialog';
// window.ModalDialog = BootstrapModalDialog;

// import { LiveClock } from './components/LiveClock';
// window.LiveClock = LiveClock;

// import { LiveProduction } from './components/LiveProduction';
// window.LiveProduction = LiveProduction;

// import { ColorGenerator } from './components/ColorGenerator';
// window.ColorGenerator = ColorGenerator;


// Mimes map
window.mimeIconMap = {
    '_default': '<i class="fa-regular fa-file color-blue-gray"></i>',
    'application/pdf': '<i class="fa-regular fa-file-pdf color-red"></i>',
    'image/jpeg': '<i class="fa-regular fa-file-image color-blue-gray"></i>',
    'image/png': '<i class="fa-regular fa-file-image color-blue-gray"></i>',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':'<i class="fa-regular fa-file-excel color-green"></i>',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':'<i class="fa-regular fa-file-word color-dark-blue"></i>',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':'<i class="fa-regular fa-file-powerpoint color-orange"></i>',
};
